import { useQuery } from '@apollo/client'
import { css, useTheme } from '@fable/theme'
import { PageContainer, Text } from '@fable/components'
import { useErrorModal } from '../../../hooks'
import { GET_EVENT_LIST } from '../../community/queries/events'
import { HomeEventCard } from './HomeEventCard'
import pinkShape from '../../../assets/images/graphics/pink-shape-with-dots.webp'
import yellowShape from '../../../assets/images/graphics/yellow-blob-shape-white-lines.webp'
import { BlogEvent } from '../../../types'

const HomeEvent: React.VFC<{ className?: string }> = ({ className = '' }) => {
  const { colors, mediaQueries } = useTheme()
  const id = '7nGhy7WEDldbSaloVQrUz3'
  const { data, loading, error } = useQuery(GET_EVENT_LIST, {
    variables: { id },
  })
  const headerTitle = 'Upcoming Live Event'

  useErrorModal(error)

  const event =
    (data?.eventList?.eventsCollection?.items[0] as BlogEvent) || null

  return loading || !event ? null : (
    <section data-testid="featuredEventHome" className={className}>
      <PageContainer
        card
        marginEdges
        className={css`
          padding: 48px 16px 96px;
          background: ${event.primaryColor};
          overflow: hidden;
          position: relative;
          ${mediaQueries.mobileL} {
            padding: 48px 18px 80px;
          }
          ${mediaQueries.tablet} {
            margin-left: 0;
            margin-right: 0;
            margin-bottom: 60px;
            padding: 48px 36px 60px;
          }
          ${mediaQueries.desktop} {
            margin-bottom: 72px;
            padding: 48px 48px 106px;
          }
        `}
      >
        <div>
          <div
            className={css`
              position: relative;
              z-index: 1;
            `}
          >
            <Text
              className={css`
                margin: 0 auto 30px;
                width: 100%;
                text-align: center;
                ${mediaQueries.desktop} {
                  display: none;
                }
              `}
              type="subhead"
              sizing="L"
              color={
                event.theme === 'light' ? colors.graphite : colors.whiteFang
              }
              text={headerTitle}
            />
            <div
              className={css`
                margin: 0 auto;
              `}
            >
              <HomeEventCard event={event} />
            </div>
          </div>
        </div>
        <img
          className={css`
            display: none;
            ${mediaQueries.desktop} {
              display: block;
              width: 25.373vw;
              position: absolute;
              bottom: -2px;
              left: 65%;
              transform: translateX(-50%);
            }
          `}
          src={pinkShape}
          alt="Pink shape with black dots"
        />
        <img
          className={css`
            display: none;
            ${mediaQueries.desktop} {
              display: block;
              width: 18.159vw;
              position: absolute;
              bottom: -2px;
              right: -48px;
            }
          `}
          src={yellowShape}
          alt="Yellow shape with white lines"
        />
      </PageContainer>
    </section>
  )
}

export default HomeEvent
